module.exports = __webpack_public_path__ + "img/4_103.19613eaa.png";